import { Component, OnInit } from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Offer } from '../../models/Offer';
import { NavBarService } from '../../services/nav-bar/nav-bar.service';
import { DataService } from '../../shared/services/data.service';
import { BaseHttpService } from '../../services/base-http/base-http.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('routeAnimation', [
      state('*', style({ opacity: 1 })),
      transition('void => *', [style({ opacity: 0 }), animate(300)]),
      transition('* => void', animate(0, style({ opacity: 0 }))),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  sellableOffers: Array<Offer>;
  rentableOffers: Array<Offer>;
  commentsVisible: boolean;

  constructor(
    private nav: NavBarService,
    private data: DataService,
    private httpService: BaseHttpService
  ) {}

  ngOnInit() {
    this.data.currentComments.subscribe(
      (comments) => (this.commentsVisible = comments)
    );
    this.getSliderOffers();
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.homeSelected = true;
    }, 0);
  }

  getSliderOffers() {
    this.httpService.getMainPageSlidersOffers().subscribe((dataOffers) => {
      this.rentableOffers = [];
      this.sellableOffers = [];
      for (let i = 0; i < dataOffers.length; i++) {
        const offer = dataOffers[i];
        if (offer.property_for_sale) {
          this.sellableOffers.push(new Offer(offer));
        } else {
          this.rentableOffers.push(new Offer(offer));
        }
      }
    });
  }
}
